import { ChangeEvent } from "react";
import { useDispatch } from "react-redux";
import { TableBody as Body, TableCell, TableRow } from "@mui/material";
import dayjs from "dayjs";

import { HeaderProperties } from "../../../shared/uiComponents/Table/tableProperties";
import { CustomCheckBox } from "../../../shared/uiComponents";
import { ViewSoapNote } from "../../SOAPNotes/DSUNotes/tableInfo";

import { DispatchProperties, useSelector } from "../../../redux/store";
import { SoapNotesApprovalProperties } from "../../../redux/API/ClientAPIHelpers/soapNoteProperties";
import { setReportIds } from "../../../redux/State/clientSlice/billingSlice";
import { useSearchParams } from "react-router-dom";

export const Headers: Array<HeaderProperties> = [
  { id: "0", name: "", width: '40px', isSelectAll: true },
  { id: "1", name: "Provider", orderBy: "client.fullName" },
  { id: "2", name: "Client", orderBy: "client.fullName" },
  { id: "3", name: "Session Date", orderBy: "sessionDate" },
  { id: "4", name: "View" },
];

const CheckboxTableCell = ({ id }: { id: string }) => {
  const dispatch = useDispatch<DispatchProperties>();
  const [params] = useSearchParams();
  const selectAll = params.get("selectAll") === "true" ? true : false;

  const reportIds = useSelector((state) => state.billing.billingFilters.reportIds);

  const selectNoteHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    if (checked) {
      dispatch(setReportIds([...reportIds, id]))
      return;
    }
    dispatch(setReportIds(reportIds.filter(x => x !== id)))
  }

  return (
    <TableCell style={{ width: '40px', textAlign: 'center' }} padding={'checkbox'}>
      <CustomCheckBox
        item={{
          id: id,
          checked: reportIds.includes(id) || selectAll,
          disabled: selectAll,
        }}
        onChange={selectNoteHandler}
        style={{ marginRight: 0 }}
      />
    </TableCell>
  )
}

export const TableBody = ({
  data,
}: {
  data: Array<SoapNotesApprovalProperties>;
}) => {
  return (
    <Body>
      {data.map((row, index) => (
        <TableRow key={index}>
          <CheckboxTableCell id={row.id} />
          <TableCell>{row.user.fullName}</TableCell>
          <TableCell>{row.client.fullName}</TableCell>
          <TableCell>{dayjs.utc(row.date).format("MM-DD-YYYY")}</TableCell>
          <TableCell>
            <ViewSoapNote item={row} />
          </TableCell>
        </TableRow>
      ))}
    </Body>
  );
};

